import { render, staticRenderFns } from "./ReportLabels.vue?vue&type=template&id=45c97a2e&"
import script from "./ReportLabels.vue?vue&type=script&lang=js&"
export * from "./ReportLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports